export interface DishViewSettings {
  viewingId: number;
  dishData: any;
  notes: string;
  quantity: number;
  modifierOptions: {
    chooseOneOnlyGroup: any;
    addOneGroup: any;
    addMultipleGroup: any;
  };
  requiredModifierIdList: number[];
}
export default {
  quantity: 1,
  modifierOptions: {},
} as DishViewSettings;

export const spaceName = 'caDish';
